import { combineReducers } from 'redux';
import { question, questionInitialState } from './question';
import { photoInitialState, photo } from './photo';
import { result, resultInitialState } from './result';
import { wkwebviewPhoto, wkwebviewphotoInitialState } from './wkwebview';
import { resultHistory, resultHistoryInitialState } from './result-history';
import { musicPlayer, musicPlayerInitialState } from './music-player';
import { reducer as formReducer } from 'redux-form';
import { user, userInitialState } from './user';

const initialState = {
  ...musicPlayerInitialState,
  ...questionInitialState,
  ...photoInitialState,
  ...resultInitialState,
  ...resultHistoryInitialState,
  ...wkwebviewphotoInitialState,
  ...userInitialState,
};

export default combineReducers({
  form: formReducer,
  musicPlayer,
  question,
  photo,
  result,
  resultHistory,
  wkwebviewPhoto,
  user,
});

export { initialState };



// WEBPACK FOOTER //
// ./src/reducers/index.js